import { render, staticRenderFns } from "./DialogArticleEdit.vue?vue&type=template&id=77d0c8a4"
import script from "./DialogArticleEdit.vue?vue&type=script&lang=js"
export * from "./DialogArticleEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogArticleEdit.vue?vue&type=style&index=0&id=77d0c8a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports